<template>
  <div id="home" class="pos_container_panel">
    <el-form :model="InvoicingInfo.orderInfo" label-width="180px" class="orderForm form" :disabled= "InvoicingInfo.showForm">
      <el-form-item :label="$t('INVOICINGINFO.TOTALPRICE')">
        <span>{{ getTotalPrice(InvoicingInfo.orderInfo)}}</span>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.INVOICINGPRICE')">
        <span>{{ getInvoicingPrice(InvoicingInfo.orderInfo)}}</span>
        <span v-if="!isEditInvoicingDetail" style="margin-left: 20px;color:blue">{{ getInvoicingDetail(InvoicingInfo.orderInfo)}}</span>
        <el-icon v-if="$objBaseInfo.sourceType == 'CRM'" class="edit-invoicing-icon" @click="editInvoicingDetail"><Edit /></el-icon>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.INVOICINGTYPE')">
        <el-radio-group v-model="InvoicingInfo.choseInvoicingType" @input="changeInvoicingType">
          <el-radio v-for="item in InvoicingInfo.invoicingType" :key="item.id" :label="item.id">{{item.value}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.INVOICIGSTITLE')">
        <span v-if="InvoicingInfo.invoicingTitle == 1">{{ $t('INVOICINGINFO.INVOICINGCOMPANY') }}</span>
        <span v-if="InvoicingInfo.invoicingTitle == 2">{{ $t('INVOICINGINFO.INVOICINGCOMPANY1') }}</span>
      </el-form-item>
      <!-- <el-form-item :label="$t('INVOICINGINFO.INVOICINGSERVICEFEES')">
        <el-checkbox v-model="serviceFeesChecked" :disabled="showServiceFees"></el-checkbox>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.SERVICEFEESINVOICINGTYPE')">
        <el-radio-group v-model="InvoicingInfo.choseServiceFeesInvoiicngType">
          <el-radio v-for="item in InvoicingInfo.invoicingType" :key="item.id" :label="item.id" :disabled="!serviceFeesChecked">{{item.value}}</el-radio>
        </el-radio-group>
      </el-form-item> -->
    </el-form>
    <div style="padding:0 15rem;">
      <i class="el-icon-warning" style="color:rgb(42 172 221)"></i>
      {{ $t('INVOICINGINFO.TIPS') }}
    </div>
    <el-form :model="InvoicingInfo.choseinvoicing" label-width="180px" class="form" ref="choseinvoicing" :rules="invoicingRules" :disabled= "InvoicingInfo.showForm">
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.TITLE')" style="text-align: right;">
          <a href="javascript:void(0);" @click="instruction" target="_self">{{ $t('INVOICINGINFO.INVOICINGDETAILINFO.INSTRUCTION') }}</a>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADERTYPE')">
          <div style="display: grid;grid-template-columns: 7fr 1fr;">
            <div>
              <el-radio-group v-model="InvoicingInfo.choseinvoicing.invoiceType" @change="changeInvoiceType('choseinvoicing')">
                <el-radio label="2" :disabled = "InvoicingInfo.showInvoiceTypeRadio">{{ $t("INVOICINGHEADERTYPE.PERSONS") }}</el-radio>
                <el-radio label="1" :disabled = "InvoicingInfo.showInvoiceTypeRadio">{{ $t("INVOICINGHEADERTYPE.CORPORATION") }}</el-radio>
                <el-radio label="3" :disabled = "!InvoicingInfo.showInvoiceTypeRadio">{{ $t("INVOICINGHEADERTYPE.NOCORPORATION") }}</el-radio>
              </el-radio-group>
            </div>
            <div>
              <el-button class="button_style" @click="showInvoicingList" v-if="!InvoicingInfo.showForm">{{ $t("INVOICINGBUTTON.CHOSEHEADER") }}</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')" prop="headerName">
          <el-input v-model="InvoicingInfo.choseinvoicing.headerName" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')})" @input="handleInput('headerName',true)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')" prop="taxCode">
          <el-input v-model="InvoicingInfo.choseinvoicing.taxCode" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBERPLACEHOLDER')" @input="handleInput('taxCode',true)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNAME')" prop="bank">
          <el-input v-model="InvoicingInfo.choseinvoicing.bank" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNAME')})"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')" prop="bankAccountNumber">
          <el-input v-model="InvoicingInfo.choseinvoicing.bankAccountNumber" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')})" @input="handleInput('bankAccountNumber',true)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDADDRESS')" prop="registeredAddress">
          <el-input v-model="InvoicingInfo.choseinvoicing.registeredAddress" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDADDRESS')})" @input="handleInput('registeredAddress',true)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDPHONE')" prop="registeredPhone">
          <el-input v-model="InvoicingInfo.choseinvoicing.registeredPhone" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDPHONE')})" @input="handleInput('registeredPhone',true)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.DETAIL')">
          <div class="detail-content">
            <div>{{ $t('INVOICINGINFO.INVOICINGDETAILINFO.DETAILMSG_LINE1', { totalPrice: roomFees }) }}</div>
            <div>{{ $t('INVOICINGINFO.INVOICINGDETAILINFO.DETAILMSG_LINE2', { serviceFees: serviceFees }) }}</div>
          </div>
        </el-form-item>
    </el-form>
    <div style="padding:0 15rem;">
      <i class="el-icon-warning" style="color:rgb(42 172 221)"></i>
      {{ $t('INVOICINGINFO.TIPS1') }}
    </div>
    <el-form :model="InvoicingInfo.choseContact" label-width="180px" class="form" :rules="contactRules" ref="InvoicingInfo.choseContact" :disabled= "InvoicingInfo.showForm">
      <el-form-item :label="$t('INVOICINGINFO.CONTACTSINFO.CONTACTSMSG')">
        <el-button class="button_style" @click="showContactsList" v-if="!InvoicingInfo.showForm">{{ $t("INVOICINGBUTTON.CHOSECONTACTS") }}</el-button>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.CONTACTSINFO.NAME')" prop="personName">
        <el-input v-model="InvoicingInfo.choseContact.personName" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.NAME')})"></el-input>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.CONTACTSINFO.PHONE')"  prop="personPhone">
        <el-input v-model="InvoicingInfo.choseContact.personPhone" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.PHONE')})"></el-input>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.CONTACTSINFO.EMAIL')"  prop="personEmail">
        <el-input v-model="InvoicingInfo.choseContact.personEmail" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.EMAIL')})"></el-input>
      </el-form-item>
    </el-form>
    <el-footer style="text-align: right;height: auto;">
      <el-button class="button_style" @click="saveInvoiceRecoed" v-if="!InvoicingInfo.showForm">{{ $t("INVOICINGBUTTON.SUBMIT") }}</el-button>
      <el-button class="button_style" @click="resentInvoice" v-if="isShowRepeatEmail">{{ $t("INVOICINGBUTTON.RESENT") }}</el-button>
    </el-footer>
    <!-- begin 修改开票金额 dialog -->
    <el-dialog v-model="editInvoicingDetailDialog" :show-close="false"  width="40rem">
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :inline="true" label-width="82px">
        <el-row>
          <el-col>
            <el-form-item :label="$t('REFUNDREQUESTINFO.ROOMCHARGE')">
              <el-input size="small" v-model="roomFees" type ="Number" @blur="changeRoomFeesInput()"></el-input>
            </el-form-item>
            <el-form-item :label="$t('REFUNDREQUESTINFO.FREE')">
              <el-input size="small" v-model="serviceFees" type ="Number" @blur="changeServiceFeesInput()"></el-input>
            </el-form-item>
            <el-form-item>
              <span>{{ "修改房费或者服务费时，不能超过订单的金额" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- end 修改开票金额 dialog -->
    <!-- begin 发票说明 dialog -->
    <el-dialog v-model="instructionDialog" :show-close="false"  width="40rem">
      <el-divider class="title-headerDivider"></el-divider>
      <span v-html="$t('INVOICINGINFO.INVOICINGDETAILINFO.INSTRUCTIONMSG')"></span>
    </el-dialog>
    <!-- end 发现说明 dialog -->
    <!-- begin 发票抬头列表 dialog -->
    <el-dialog class="invoiceHeader" v-model="showInstructionDetailDialog" :show-close="false" @close="closeInstructionDetail"  width="800px">
      <el-tabs v-model="activeName" :stretch="true">
        <el-tab-pane name="first">
          <template #label>
            <span><i class="el-icon-s-custom"></i>{{ $t('INVOICINGINFO.PERSONALINVOICEHEADER') }}</span>
          </template>
          <el-divider class="title-headerDivider"></el-divider>
          <div v-for="(item,index) in InvoicingInfo.invoicingData" :key="index" >
            <el-descriptions class="margin-top" :column="2" :title= item.headerName border>
              <template #extra>
                <span v-if="item.isDefault" style="color: #FF694B;margin-right: 10px;">{{ $t('INVOICINGINFO.DEFAULT') }}</span>
                <a href="javascript:void(0);" @click="choseHeader(item)">{{ $t('INVOICINGBUTTON.CHOSE') }}</a>
                <a href="javascript:void(0);" v-if="!item.isDefault" @click="setDefault(item)" style="margin-left: 10px;">{{ $t('INVOICINGBUTTON.ISFIRST') }}</a>
                <a href="javascript:void(0);" @click="editHeader(item)" style="margin-left: 10px;">{{ $t('INVOICINGBUTTON.DEIT') }}</a>
                <a href="javascript:void(0);" @click="deleteHeader(item)" style="margin-left: 10px;">{{ $t('INVOICINGBUTTON.DELETE') }}</a>
              </template>
              <el-descriptions-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADERTYPE')">{{ getTitleType(item.invoiceType) }}</el-descriptions-item>
              <el-descriptions-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')">{{ item.taxCode }}</el-descriptions-item>
              <el-descriptions-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNAME')">{{ item.bank }}</el-descriptions-item>
              <el-descriptions-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')">{{ item.bankAccountNumber }} </el-descriptions-item>
              <el-descriptions-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDPHONE')">{{ item.registeredPhone }}</el-descriptions-item>
              <el-descriptions-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDADDRESS')">{{ item.registeredAddress }}</el-descriptions-item>
            </el-descriptions>
            <el-divider ></el-divider>
          </div>
          <el-footer style="text-align: right;height: auto;" v-if="InvoicingInfo.invoicingData.length < 3">
            <el-button class="button_style" @click="addHeader">{{ $t("INVOICINGBUTTON.ADDINVOICING") }}</el-button>
          </el-footer>
        </el-tab-pane>
        <el-tab-pane name="second" v-if="InvoicingInfo.customInvoiceHeaderList.length > 0">
          <template #label>
            <span><i class="el-icon-s-home"></i>{{ $t("INVOICINGINFO.CORPORATERETRIEVEDINVOICEHEADER") }}</span>
          </template>
          <el-main style="padding-top: 0; padding-bottom: 0">
            <el-table :data="InvoicingInfo.customInvoiceHeaderList" border width="100%">
              <el-table-column prop="headerName"  align="center"  :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')"></el-table-column>
              <el-table-column prop="taxCode"  align="center" :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')"></el-table-column>
              <el-table-column prop="bankAccountNumber"  align="center" :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')"></el-table-column>
              <el-table-column  align="center" :label="$t('ORDERLIST.Operation')" fixed="right">
              <template #default="scope">
                <el-button @click="showHeader(scope.row)" type="text" size="small">
                  {{ $t("ORDERLIST.Detail") }}
                </el-button>
                <el-button @click="choseHeader(scope.row)" type="text" size="small">
                  {{ $t('INVOICINGBUTTON.CHOSE') }}
                </el-button>
              </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer style="margin: 1rem 2rem; background-color: #ffffff">
            <el-pagination style="float: right; margin: 1rem 0" background layout="total,prev, pager, next" 
            :page-size="InvoicingInfo.pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange" 
            :total="InvoicingInfo.totalCount" :current-page="InvoicingInfo.pageIndex">
            </el-pagination>
          </el-footer>
        </el-tab-pane>
      </el-tabs>
      
    </el-dialog>
    <!-- end 发票抬头列表 dialog -->
    <!-- begin 发票抬头详情 dialog -->
    <el-dialog v-model="showInvoicingDetailDialog" :show-close="false">
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :model="InvoicingInfo.invoicingDetailData" label-width="100px" ref="invoicingForm" :rules="invoicingRules">
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADERTYPE')">
          <div style="display: grid;grid-template-columns: 7fr 1fr;">
            <div>
              <span>{{ InvoicingInfo.getAddInvoicingInfo}}</span>
              <!-- <el-radio-group v-model="InvoicingInfo.invoicingDetailData.invoiceType" @change="changeInvoiceType('InvoicingInfo.invoicingDetailData')">
                <el-radio label="2" style="margin-left: 3rem">{{ $t("INVOICINGHEADERTYPE.PERSONS") }}</el-radio>
                <el-radio label="1">{{ $t("INVOICINGHEADERTYPE.CORPORATION") }}</el-radio>
                <el-radio label="3" style="margin-left: 3rem">{{ $t("INVOICINGHEADERTYPE.NOCORPORATION") }}</el-radio>
              </el-radio-group> -->
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')" prop="headerName">
          <el-input v-model="InvoicingInfo.invoicingDetailData.headerName" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')})" @input="handleInput('headerName',false)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')" prop="taxCode">
          <el-input v-model="InvoicingInfo.invoicingDetailData.taxCode" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBERPLACEHOLDER')" @input="handleInput('taxCode',false)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNAME')" prop="bank">
          <el-input v-model="InvoicingInfo.invoicingDetailData.bank" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNAME')})"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')" prop="bankAccountNumber">
          <el-input v-model="InvoicingInfo.invoicingDetailData.bankAccountNumber" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')})" @input="handleInput('bankAccountNumber',false)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDADDRESS')" prop="registeredAddress">
          <el-input v-model="InvoicingInfo.invoicingDetailData.registeredAddress" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDADDRESS')})" @input="handleInput('registeredAddress',false)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDPHONE')" prop="registeredPhone">
          <el-input v-model="InvoicingInfo.invoicingDetailData.registeredPhone" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDPHONE')})" @input="handleInput('registeredPhone',false)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGBUTTON.ISFIRST')">
          <el-switch v-model="InvoicingInfo.invoicingDetailData.isDefault"  active-color="#13ce66" :active-text="$t('INVOICINGBUTTON.OPENISFIRST')" :inactive-text="$t('INVOICINGBUTTON.CLOSEISFIRST')"></el-switch>
        </el-form-item>
        <el-footer style="text-align: right;height: auto;">
          <el-button class="button_style" @click="saveDetail">{{ $t("INVOICINGBUTTON.SAVE") }}</el-button>
        </el-footer>
      </el-form>
    </el-dialog>
    <!-- end 发票抬头详情 dialog -->
    <!-- begin 联系人列表 dialog -->
    <el-dialog v-model="showContactsListDialog" :show-close="false">
      <el-divider class="title-headerDivider"></el-divider>
      <div v-for="(item,index) in InvoicingInfo.contactsData" :key="index" >
        <el-descriptions class="margin-top" :column="3" :title= item.headerName>
          <template #extra>
            <span v-if="item.isDefault" style="color: #FF694B;margin-right: 10px;">{{ $t('INVOICINGINFO.DEFAULT') }}</span>
            <a href="javascript:void(0);" @click="choseContacts(item)">{{ $t('INVOICINGBUTTON.CHOSE') }}</a>
            <a href="javascript:void(0);" v-if="!item.isDefault" @click="setContactsDefault(item)" style="margin-left: 10px;">{{ $t('INVOICINGBUTTON.ISFIRST') }}</a>
            <a href="javascript:void(0);" @click="editContacts(item)" style="margin-left: 10px;">{{ $t('INVOICINGBUTTON.DEIT') }}</a>
            <a href="javascript:void(0);" @click="deleteContacts(item)" style="margin-left: 10px;">{{ $t('INVOICINGBUTTON.DELETE') }}</a>
          </template>
          <el-descriptions-item :label="$t('INVOICINGINFO.CONTACTSINFO.NAME')">{{ item.personName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('INVOICINGINFO.CONTACTSINFO.PHONE')">{{ item.personPhone }}</el-descriptions-item>
          <el-descriptions-item :label="$t('INVOICINGINFO.CONTACTSINFO.EMAIL')">{{ item.personEmail }}</el-descriptions-item>
        </el-descriptions>
        <el-divider ></el-divider>
      </div>
      <el-footer style="text-align: right;height: auto;" v-if="InvoicingInfo.contactsData.length < 3">
        <el-button class="button_style" @click="addContacts">{{ $t("INVOICINGBUTTON.ADDCONTACTS") }}</el-button>
      </el-footer>
    </el-dialog>
    <!-- end 联系人列表 dialog -->
    <!-- begin 联系人详情 dialog -->
    <el-dialog v-model="showContactsDetailDialog" :show-close="false">
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :model="InvoicingInfo.contactsDetailData" label-width="100px" :rules="contactRules" ref="InvoicingInfo.contactsDetailData">
        <el-form-item :label="$t('INVOICINGINFO.CONTACTSINFO.NAME')" prop="personName">
          <el-input v-model="InvoicingInfo.contactsDetailData.personName" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.NAME')})"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.CONTACTSINFO.PHONE')" prop="personPhone">
          <el-input v-model="InvoicingInfo.contactsDetailData.personPhone" :placeholder="$t('INVOICINGINFO.CONTACTSINFO.PHONE')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.CONTACTSINFO.EMAIL')" prop="personEmail">
          <el-input v-model="InvoicingInfo.contactsDetailData.personEmail" :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.EMAIL')})"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGBUTTON.ISFIRST')">
          <el-switch v-model="InvoicingInfo.contactsDetailData.isDefault"  active-color="#13ce66" :active-text="$t('INVOICINGBUTTON.OPENISFIRST')" :inactive-text="$t('INVOICINGBUTTON.CLOSEISFIRST')"></el-switch>
        </el-form-item>
        <el-footer style="text-align: right;height: auto;">
          <el-button class="button_style" @click="saveContactsDetail">{{ $t("INVOICINGBUTTON.SAVE") }}</el-button>
        </el-footer>
      </el-form>
    </el-dialog>
    <!-- end 联系人详情 dialog -->
    <!-- begin 公司发票抬头详情 dialog -->
    <el-dialog v-model="showCustomInvoicingDetailDialog" :show-close="false">
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :model="CustomInvoicingDetail" label-width="100px" ref="invoicingForm">
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')" prop="headerName">
          <el-input :disabled="true" v-model="CustomInvoicingDetail.headerName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')" prop="taxCode">
          <el-input :disabled="true" v-model="CustomInvoicingDetail.taxCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNAME')" prop="bank">
          <el-input :disabled="true" v-model="CustomInvoicingDetail.bank"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')" prop="bankAccountNumber">
          <el-input :disabled="true" v-model="CustomInvoicingDetail.bankAccountNumber"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDADDRESS')" prop="registeredAddress">
          <el-input :disabled="true" v-model="CustomInvoicingDetail.registeredAddress"></el-input>
        </el-form-item>
        <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDPHONE')" prop="registeredPhone">
          <el-input :disabled="true" v-model="CustomInvoicingDetail.registeredPhone"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- end 公司发票抬头详情 dialog -->
  </div>
</template>
<script>
import { Edit } from "@element-plus/icons-vue";

export default {
  name: "invoicingPC",
  components: {
    Edit,
  },
  inject: ['InvoicingInfo'],
  data() {
    return {
        isEditInvoicingDetail:false,
        editInvoicingDetailDialog:false,
        roomFees: "",
        maxRoomFees: "",
        serviceFees: "",
        maxServiceFees: "",
        serviceFeesChecked: false,
        instructionDialog:false,
        showInstructionDetailDialog:false,
        showContactsDetailDialog:false,
        showInvoicingDetailDialog:false,
        showInvoicingDetailInput:true,
        showContactsListDialog:false,
        contactInfo:{
          name:"",
          phone:"",
          email:"",
        },
        checkPersonInvoicing:['headerName'],
        checkCorporationInvoicing:['headerName','taxCode'],
        NonRequiredValidation:['bankAccountNumber','registeredAddress','registeredPhone'],
        checkCorporationInvoicingRequired:false,
        showServiceFees:false,
        isShowRepeatEmail:false,
        activeName:"first",
        showCustomInvoicingDetailDialog:false,
        CustomInvoicingDetail:[]
    };
  },
  computed: {
    getTotalPrice(){
      return (item) => {
        return this.$currencySign[item.currencyCode] + " " + item.totalPrice;
      }
    },
    getInvoicingPrice(){
      return (item) => {
        if(this.serviceFees == "0.00"){
          this.showServiceFees = true;
        }
        return this.$currencySign[item.currencyCode] + " " + (Number(this.roomFees) + Number(this.serviceFees)).toFixed(2);
      }
    },
    getInvoicingDetail(){
      return () => {
        return this.$t("INVOICINGINFO.INVOICINGDETAIL",{roomFees : this.roomFees ,serviceFees: this.serviceFees});
      }
    },
    getTitleType(){
      return (item) => {
        if(item == "1"){
          return this.$t("INVOICINGHEADERTYPE.CORPORATION");
        }else if(item == "2"){
          return this.$t("INVOICINGHEADERTYPE.PERSONS");
        }else{
          return this.$t("INVOICINGHEADERTYPE.NOCORPORATION");
        }
      }
    },
    contactRules() {
      return {
        "personName": [{ required: !this.InvoicingInfo.showForm, message: this.$t("MANUAL.VALIDATECONTACTNAME"), trigger: ["blur", "change"], }],
        "personPhone": [
          { required: !this.InvoicingInfo.showForm, message: this.$t("MANUAL.VALIDATECONTACTMOBILE"), trigger: ["blur", "change"], },
          { pattern: /^1[3456789]\d{9}$/, message: this.$t("MANUAL.VALIDATEPHONEFORMAT"), trigger: ["blur", "change"], }
        ],
        "personEmail": [
          { required: !this.InvoicingInfo.showForm, message: this.$t("MANUAL.VALIDATECONTACTEMAIL"), trigger: ["blur", "change"], },
          { type: "email", message: this.$t("USERDIALOG.GUESTEMAIL2"), trigger: ["blur", "change"], }
        ],
      }
    },
    invoicingRules() {
      return {
        "headerName": [{ required: !this.InvoicingInfo.showForm, message: this.$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : this.$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')}), trigger: ["blur", "change"], },
                       { validator: this.validateHeaderName, trigger: ["blur", "change"] }],
        "taxCode": [{ required: !this.InvoicingInfo.showForm && this.checkCorporationInvoicingRequired, message: this.$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : this.$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')}), trigger: ["blur", "change"], },
                    { validator: this.validateIdentifier, trigger: ["blur", "change"]  }],
        "bankAccountNumber": [{ validator: this.validateInputNumber, trigger: ["blur", "change"]  }],
        "registeredAddress": [{ validator: this.validateInputNumber, trigger: ["blur", "change"]  }],
        "registeredPhone": [{ validator: this.validateInputNumber, trigger: ["blur", "change"]  }],
      }
    },
  },
  watch: {},
  mounted() {
  },
  methods: {
    handleInput(field,isListCheck) {
      // 用户输入时，手动触发验证
      if(isListCheck){
        this.$refs.choseinvoicing.validateField(field).catch(() => {});
      }else{
        this.$refs.invoicingForm.validateField(field).catch(() => {});
      }
    },
    validateInputNumber(rule, value, callback) {
      const maxLength = 100; // 最大字符数
      let length = 0;
      const valueLength = value?.length || 0;
      for (let i = 0; i < valueLength; i++) {
        if (value.charCodeAt(i) > 127) {
          length += 2; // 汉字长度计为2
        } else {
          length += 1; // 英文字母和其他字符长度计为1
        }
      }

      if (length > maxLength) {
        callback(new Error(this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateInputCharacters')));
      } else {
        callback();
      }
    },
    validateIdentifier(rule, value, callback) {
      const pattern = /^[A-Za-z0-9]{7,20}$/;
      if (value === '') {
        callback();
      } else if (!pattern.test(value)) {
        callback(new Error(this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateInputTaxNumber')));
      } else {
        callback();
      }
    },
    validateHeaderName(rule, value, callback) {
      const invoicingTitle = this.InvoicingInfo.invoicingTitle;
      const errorMsg = this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateHeaderName');
      if ((invoicingTitle === 1 && value === this.$t('INVOICINGINFO.INVOICINGCOMPANY')) || (invoicingTitle === 2 && value === this.$t('INVOICINGINFO.INVOICINGCOMPANY1'))) {
        callback(new Error(errorMsg));
      }else {
        this.validateInputNumber(rule, value, callback);
      }
    },
    // #region 发票抬头功能
    editInvoicingDetail(){
      this.editInvoicingDetailDialog = true;
    },
    instruction(){
      this.instructionDialog = true;
    },
    showInvoicingList(){
      this.showInvoicingDetailDialog = false;
      this.showInstructionDetailDialog = true;
      this.InvoicingInfo.getInvoiceHeader();
    },
    choseHeader(val){
      let param = {
        invoiceType: val.invoiceType,
        headerName: val.headerName,
        taxCode: val.taxCode,
        bank: val.bank,
        bankAccountNumber: val.bankAccountNumber,
        registeredAddress: val.registeredAddress,
        registeredPhone: val.registeredPhone, 
        isDefault: val.isDefault,
      };
      this.InvoicingInfo.choseinvoicing = param;
      this.showInstructionDetailDialog = false;
      this.changeInvoiceType("choseinvoicing");
    },
    setDefault(val){
      let Params = {
        id: val.id,
        customerCode: val.customerCode,
        invoiceType: val.invoiceType,
        headerName: val.headerName,
        taxCode: val.taxCode,
        bank: val.bank,
        bankAccountNumber: val.bankAccountNumber,
        registeredAddress: val.registeredAddress,
        registeredPhone: val.registeredPhone,
        isDefault: true,
      };
      this.InvoicingInfo.saveInvoiceHeader({ 
        params: Params,
        key:"Edit"
      });
    },
    editHeader(val){
      let detail = this.InvoicingInfo.invoicingData.find((item) => {
        if (item.id === val.id) {
          return item;
        }
      })
      this.InvoicingInfo.invoicingDetailData = detail;
      // this.InvoicingInfo.getInvoiceHeader({ 
      //   id: val.id,
      // });
      this.showInvoicingDetailDialog = true;
      
    },
    async saveDetail(){
      let fieldList = [];
      this.$refs["invoicingForm"].clearValidate();//重置表单
      if(this.InvoicingInfo.invoicingDetailData.invoiceType == "1"){
        fieldList = this.checkCorporationInvoicing;
      }else if(this.InvoicingInfo.invoicingDetailData.invoiceType == "2"){
        fieldList = this.checkPersonInvoicing;
      }else if(this.InvoicingInfo.invoicingDetailData.invoiceType == "3"){
        fieldList = this.checkCorporationInvoicing;
      }
      try {
        await this.$refs["invoicingForm"].validateField([
          ...fieldList,
          ...this.NonRequiredValidation,
        ]);
        this.InvoicingInfo.saveInvoiceHeader({
          params: this.InvoicingInfo.invoicingDetailData,
          key:"Edit"
        });
      } catch (error) {
        // Element Plus rejects validation with the invalid field name.
        return;
      }
    },
    deleteHeader(val){
      this.$confirm(this.$t("INVOICINGINFO.DELETEMSG"), '', {
        confirmButtonText: this.$t("INVOICINGBUTTON.CONFIRM"),
        cancelButtonText: this.$t("INVOICINGBUTTON.CANCEL"),
        type: 'warning'
      }).then(() => {
        let Params = {
          id: val.id,
          userId: val.userId,
          customerCode: val.customerCode,
          invoiceType: val.invoiceType,
          headerName: val.headerName,
          taxCode: val.taxCode,
          bank: val.bank,
          bankAccountNumber: val.bankAccountNumber,
          registeredAddress: val.registeredAddress,
          registeredPhone: val.registeredPhone,
          isDefault: val.isDefault,
          isDel: 1,
        };
        this.InvoicingInfo.saveInvoiceHeader({ 
          params: Params,
          key:"Delete"
        });
      })
    },
    addHeader(){
      this.changeInvoiceType('invoicingForm');
      this.InvoicingInfo.invoicingDetailData = {
        userId:this.InvoicingInfo.orderInfo.userId,
        customerCode: this.InvoicingInfo.orderInfo.customerCode,
        invoiceType: this.InvoicingInfo.choseinvoicing.invoiceType,
      };
      this.showInvoicingDetailDialog = true;
    },
    changeRoomFeesInput(){
      console.log(this.roomFees)
      if(Number(this.roomFees) > Number(this.maxRoomFees)){
        this.roomFees  = this.maxRoomFees; 
      }
      if(this.roomFees  < 0){
        this.roomFees  = 0;
      }
      this.roomFees = Number(this.roomFees).toFixed(2);
    },
    changeServiceFeesInput(){
      if(Number(this.serviceFees) > Number(this.maxServiceFees)){
        this.serviceFees  = this.maxServiceFees; 
      }
      if(this.serviceFees  < 0){
        this.serviceFees  = 0;
      }
      this.serviceFees = Number(this.serviceFees).toFixed(2);
    },
    changeInvoiceType(val){
      this.choseInvoiceTitleTypeRules(this.InvoicingInfo.choseinvoicing.invoiceType);
      this.$nextTick(() => {
        if(this.$refs[val] !=undefined){
          this.$refs[val].clearValidate();//重置表单
        }
      });
    },
    closeInstructionDetail(){
      this.changeInvoiceType("choseinvoicing");
    },
    choseInvoiceTitleTypeRules(type){
      if(type== "1"){
        this.checkCorporationInvoicingRequired = false;
      }else if(type== "2"){
        this.checkCorporationInvoicingRequired = false;
      }else if(type== "3"){
        this.checkCorporationInvoicingRequired = true;
      }
    },
    // #endregion
    // #region 联系人功能
    showContactsList(){
      this.showContactsDetailDialog = false;
      this.showContactsListDialog = true;
    },
    choseContacts(val){
      let param = {
        personName: val.personName,
        personPhone: val.personPhone,
        personEmail: val.personEmail,
        userID: val.userID,
        customerCode: val.customerCode,
      };
      this.InvoicingInfo.choseContact = param;
      this.showContactsListDialog = false;
    },
    editContacts(val){
      this.InvoicingInfo.getInvoiceContactList({ 
        id: val.id,
      });
      this.showContactsDetailDialog = true;
    },
    addContacts(){
      this.InvoicingInfo.contactsDetailData = {
        userId:this.InvoicingInfo.orderInfo.userId,
        customerCode: this.InvoicingInfo.orderInfo.customerCode,
      };
      if (this.$refs["InvoicingInfo.contactsDetailData"] !== undefined) {
        this.$refs["InvoicingInfo.contactsDetailData"].resetFields();//重置表单
      };
      
      this.showContactsDetailDialog = true;
    },
    saveContactsDetail(){
      this.$refs["InvoicingInfo.contactsDetailData"].validate((valid) => {
        if (valid) {  
          this.InvoicingInfo.saveInvoiceContact({ 
            params: this.InvoicingInfo.contactsDetailData,
            key:"Edit"
          });
        } else {
          return false;
        }
      });
    },
    deleteContacts(val){
      this.$confirm(this.$t("INVOICINGINFO.DELETEMSG"), '', {
        confirmButtonText: this.$t("INVOICINGBUTTON.CONFIRM"),
        cancelButtonText: this.$t("INVOICINGBUTTON.CANCEL"),
        type: 'warning'
      }).then(() => {
        let Params = {
          id: val.id,
          customerCode: val.customerCode,
          personName: val.personName,
          personPhone: val.personPhone,
          personEmail: val.personEmail,
          isDefault: val.isDefault,
          isDel: 1,
        };
        this.InvoicingInfo.saveInvoiceContact({ 
          params: Params,
          key:"Delete"
        });
      })
    },
    setContactsDefault(val){
      let Params = {
        id: val.id,
        userId: val.userId,
        customerCode: val.customerCode,
        personName: val.personName,
        personPhone: val.personPhone,
        personEmail: val.personEmail,
        isDel: val.isDel,
        isDefault: true,
      };
      this.InvoicingInfo.saveInvoiceContact({ 
        params: Params,
        key:"Edit"
      });
    },
    // #endregion
    async saveInvoiceRecoed(){
      let fieldList = [];
      this.$refs["choseinvoicing"].clearValidate();//重置表单
      if(this.InvoicingInfo.choseinvoicing.invoiceType == "1"){
        fieldList = this.checkCorporationInvoicing;
      }else if(this.InvoicingInfo.choseinvoicing.invoiceType == "2"){
        fieldList = this.checkPersonInvoicing;
      }else if(this.InvoicingInfo.choseinvoicing.invoiceType == "3"){
        fieldList = this.checkCorporationInvoicing;
      }
      try {
        await this.$refs["choseinvoicing"].validateField([
          ...fieldList,
          ...this.NonRequiredValidation,
        ]);
        await this.$refs["InvoicingInfo.choseContact"].validate();
      } catch (error) {
        return;
      }

      this.InvoicingInfo.saveInvoiceRecoed({
        params: {
          bookingCode:this.$route.query.orderId,
          orderAmount:this.InvoicingInfo.orderInfo.totalPrice,
          invoiceAmount: Number(this.roomFees).toFixed(2),
          invoiceTypes:this.InvoicingInfo.choseInvoicingType,
          isServiceFeeInvoice:this.serviceFeesChecked,
          serviceFeeInvoiceTypes:this.InvoicingInfo.choseServiceFeesInvoicingType,
          customerCode:this.InvoicingInfo.orderInfo.customerCode,
          userID:this.InvoicingInfo.orderInfo.userId,
          headerName:this.InvoicingInfo.choseinvoicing.headerName,
          invoiceHeaderType:this.InvoicingInfo.choseinvoicing.invoiceType,
          taxCode:this.InvoicingInfo.choseinvoicing.taxCode,
          bank:this.InvoicingInfo.choseinvoicing.bank,
          bankAccountNumber:this.InvoicingInfo.choseinvoicing.bankAccountNumber,
          registeredAddress:this.InvoicingInfo.choseinvoicing.registeredAddress,
          registeredPhone:this.InvoicingInfo.choseinvoicing.registeredPhone,
          contactPerson:this.InvoicingInfo.choseContact.personName,
          contactPhone:this.InvoicingInfo.choseContact.personPhone,
          contectEmail:this.InvoicingInfo.choseContact.personEmail,
          serviceFeeAmount:Number(this.serviceFees).toFixed(2),
        },
        key:"Save"
      });
    },
    changeInvoicingType(){
      if(this.InvoicingInfo.choseInvoicingType == 2){
        this.InvoicingInfo.showInvoiceTypeRadio = true;
        this.InvoicingInfo.choseinvoicing.invoiceType = "3";
      }else{
        this.InvoicingInfo.showInvoiceTypeRadio = false;
        this.InvoicingInfo.choseinvoicing.invoiceType = "2";
      }
      this.changeInvoiceType("choseinvoicing");
    },
    resentInvoice(){
      this.$prompt(this.$t("USERDIALOG.GUESTEMAIL"), this.$t("SERVICECHARGEINFO.HINT"), {
          confirmButtonText: this.$t("INVOICINGBUTTON.CONFIRM"),
          cancelButtonText: this.$t("INVOICINGBUTTON.CANCEL"),
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage:  this.$t("USERDIALOG.GUESTEMAIL2")
        }).then(({ value }) => {
          this.InvoicingInfo.repeatEmail({ 
                params: {
                  orderNumber:this.$route.query.orderId,
                  reEmailTo:value
                },
                key:"PC"
              });
        });
    },
    handleSizeChange(val){
      this.InvoicingInfo.pageSize = val;
      this.InvoicingInfo.getInvoiceHeader();
    },
    //分页
    handleCurrentChange(pageNum) {
      this.InvoicingInfo.pageIndex = pageNum;
      this.InvoicingInfo.getInvoiceHeader();
    },
    showHeader(val){
      this.showCustomInvoicingDetailDialog = true;
      this.CustomInvoicingDetail = val;
    }
  },
};
</script>
<style scoped>
/* .pos_container_panel {
  padding: 0 200px 40px;
} */
.form {
  background-color: white;
  margin:2rem 0;
  padding:2rem 5rem;
}
.orderForm .el-form-item {
    margin-bottom: 0px;
}
.orderForm span{
    color:red;
}
.title-headerDivider {
  margin-bottom: 1rem;
  margin-top: -1rem;
  height: 2px;
  background-color: #fc6640;
}
.button_style {
  background-color: #FF694B;
  color: #fff;
}
.edit-invoicing-icon {
  margin-left: 20px;
  color: rgb(42 172 221);
  cursor: pointer;
  vertical-align: middle;
}
.add-guest-div {
  display: block;
  float: left;
  margin-right: 6%;
  margin-top: -54px;
}
.add-guest-btn {
  padding: 8px 13px;
  background-color: #FF694B;
  color: #fff;
  pointer-events: auto;
}
::v-deep .invoiceHeader .el-dialog__body{
  padding-top: 0px;
}
::v-deep .invoiceHeader .el-dialog__header{
  padding-top: 0px;
}
::v-deep .el-table .el-table__cell {
  padding: 8px 0;
}
</style>